import * as React from "react";
import { MemoryRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../components/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import "../styles/globals.css";
import PlaceholderContainer from "./Container";

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute authenticatedElement={<PlaceholderContainer />} isPopup={true} />} />
      </Routes>
    </Router>
  );
};

export default App;


